import React from "react";

export default function Section4() {
  return (
    <div className="w-full Section3 px-5 md:px-0 pt-[2%]">
      <div className="flex flex-col items-center w-full md:flex-row justify-evenly section3-container">
        <div className="w-full md:w-[36%] text-[#373737]">
          <h2 className="text-[26px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#DA2128] my-[0.67em] pb-[2%]">
            Experienced Shopify Web Developers
          </h2>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
            Mean3 provides comprehensive Shopify design and development for startups, scaling brands, and established companies. As a leading Shopify agency in New York, we build structured, mobile-ready ecommerce websites that align with operational needs and commercial goals
          </p>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
            Our Shopify web developers  manage complete store builds, including custom storefront design, performance tuning, theme refinement, and controlled third-party integrations. Whether creating a new online store or restructuring an existing one, we focus on functionality, speed, and usability.
          </p>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
           Ready to scale your Shopify store in New York? Mean3 builds conversion-focused stores designed to drive consistent growth.
          </p>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
            
          </p>
        </div>

        <div className="w-full md:w-auto">
          <img
            src="../../../assets/computer-shopify.png"
            alt="Computer Logo"
            className="w-full md:w-auto cover"
          />
        </div>
      </div>
      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
